/*
 *
 * ChannelPage Form
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { createStructuredSelector } from 'reselect';
import { mapIsEmpty } from 'utils/helpers';
import {
  selectClients,
  selectChannelFormName,
  selectChannelFormWithFilter,
  selectChannelFormPassword,
  selectChannelModeId,
  selectCurrentTab,
  selectIsFetching,
  selectChannelThemes,
  selectModes,
  selectUseMoveboothTheme,
  selectChannelErrors,
  selectChannelSlugIsValid,
} from '../selectors';
import {
  fetchClientsRequest,
  fetchThemesRequest,
  fetchModesRequest,
  changeTab,
} from '../actions';
import BasicInfoForm from './BasicInfoForm';
import PhotographerThemeForm from './PhotographerThemeForm';
import EnterpriseThemeForm from './EnterpriseThemeForm';
import LogoForm from './LogoForm';
import PhotoOptionsForm from './PhotoOptionsForm';
import ShareOptionsForm from './ShareOptionsForm';
import BrandingForm from './BrandingForm';
import MessagingOptionForm from './MessagingOptionForm'
import validate from './validate';
import { selectIsPhotographer, selectEnterpriseAdmins } from 'containers/App/selectors';
import { setModal } from 'containers/RootModal/actions';
import { COLOR_PICKER } from 'containers/RootModal/constants';
import FormTabs from 'components/FormTabs';
import TermsForm from './TermsForm';

class Forms extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { themeIdForNew: null };
    this.setThemeIdForNew = this.setThemeIdForNew.bind(this);
  }

  componentDidMount() {
    const { onTabChange, channelThemes, fetchThemes, modes, fetchModes } = this.props;

    onTabChange(0);

    if (mapIsEmpty(channelThemes)) {
      fetchThemes();
    }
    if (mapIsEmpty(modes)) {
      fetchModes();
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.errors && this.props.errors ) {
      var errorDiscription = 'Something went wrong! ';
      Object.keys(this.props.errors).map(k => {
        var name = '';
        switch (k) {
          case 'slug':
            name = 'Gallery URL';
            errorDiscription += `${name} ${this.props.errors[k]}`;
            break;
        };
      });
      alert(errorDiscription)
      this.props.onTabChange(0)
    }
  }
  setThemeIdForNew = (val) => {
    this.setState({ themeIdForNew: val });
  }

  render() {

    const {
      fetchClients,
      channelName,
      password,
      clients,
      title,
      isNew,
      isPhotographer,
      currentTab,
      onTabChange,
      openColorPickerModal,
      fetchThemes,
      channelThemes,
      themeId,
      modes,
      modeId,
      disabled,
      nextTab,
      pristine,
      edit,
      channelThemeInstances,
      ownerRole,
      enterpriseAdmins,
      useMoveboothTheme,
      permissionRole,
      validateSlug,
      slugIsValid,
      slugIsValidating,
      withFilter,
      ...formProps
    } = this.props;
    const formsObj = {
      BASIC_INFO: {
        disabled: false,
        title: 'Basic Info',
        renderForm: () => (
          <BasicInfoForm
            clients={clients}
            fetchClients={fetchClients}
            channelName={channelName}
            edit={edit}
            isPhotographer={isPhotographer}
            disabled={disabled}
            pristine={pristine}
            enterpriseAdmins={enterpriseAdmins}
            password={password}
            nextTab={nextTab}
            isNew={isNew}
            permissionRole={permissionRole}
            slugIsValid={slugIsValid}
            slugIsValidating={slugIsValidating}
            isPhotographerOwner={ownerRole ? (ownerRole === 'photographer') : isPhotographer}
            {...formProps}
          />
        ),
      },
      PHOTO_THEME: {
        title: 'Theme',
        renderForm: () => (
          <PhotographerThemeForm
            fetchThemes={fetchThemes}
            channelThemes={channelThemes}
            themeId={themeId}
            setThemeIdFunction={this.setThemeIdForNew}
            edit={edit}
            isNew={isNew}
            channelThemeInstances={channelThemeInstances}
            nextTab={nextTab}
            permissionRole={permissionRole}
            {...formProps}
          />
        ),
      },
      ENTERPRISE_THEME: {
        title: 'Logo',
        renderForm: () => (
          <EnterpriseThemeForm
            pristine={pristine}
            isNew={isNew}
            permissionRole={permissionRole}
            openColorPickerModal={openColorPickerModal}
            {...formProps}
          />
        ),
      },
      LOGO_THEME: {
        title: 'Logo',
        renderForm: () => (
          <LogoForm
            nextTab={nextTab}
            channelThemes={channelThemes}
            themeId={themeId}
            edit={edit}
            isNew={isNew}
            pristine={pristine}
            permissionRole={permissionRole}
            channelThemeInstances={channelThemeInstances}
            openColorPickerModal={openColorPickerModal}
            filterEnabled={withFilter}
            {...formProps}
          />
        ),
      },
      PHOTO_OPTIONS: {
        title: 'Photos',
        renderForm: () => (
          <PhotoOptionsForm
            channelThemes={channelThemes}
            modes={modes}
            modeId={modeId}
            themeId={themeId}
            isNew={isNew}
            edit={edit}
            nextTab={nextTab}
            permissionRole={permissionRole}
            channelThemeInstances={channelThemeInstances}
            {...formProps}
          />
        ),
      },
      SHARE_OPTIONS: {
        title: 'Sharing',
        renderForm: () => (
          <ShareOptionsForm
            isPhotographer={isPhotographer}
            isNew={isNew}
            nextTab={nextTab}
            edit={edit}
            permissionRole={permissionRole}
            useMoveboothTheme={useMoveboothTheme}
            {...formProps}
          />
        ),
      },
      BRANDING: {
        title: 'Branding',
        renderForm: () => (
          <BrandingForm
            isPhotographer={isPhotographer}
            isNew={isNew}
            edit={edit}
            nextTab={nextTab}
            permissionRole={permissionRole}
            openColorPickerModal={openColorPickerModal}
            {...formProps}
          />
        ),
      },
      MESSAGING: {
        title: 'Messaging',
        renderForm: () => (
          <MessagingOptionForm
            isNew={isNew}
            edit={edit}
            nextTab={nextTab}
            permissionRole={permissionRole}
            openColorPickerModal={openColorPickerModal}
            {...formProps}
          />
        )
      },
      TERMS: {
        title: 'Terms',
        renderForm: () => (
          <TermsForm
            isNew={isNew}
            edit={edit}
            nextTab={nextTab}
            permissionRole={permissionRole}
            openColorPickerModal={openColorPickerModal}
            {...formProps}
          />
        )
      },
    };

    const tabs = (isPhotographer || (!isPhotographer && useMoveboothTheme)
                  ? ['BASIC_INFO', 'PHOTO_THEME', 'LOGO_THEME', 'PHOTO_OPTIONS', 'SHARE_OPTIONS']
                  : ['BASIC_INFO', 'BRANDING', 'PHOTO_OPTIONS', 'SHARE_OPTIONS', 'MESSAGING', 'TERMS']
                ).map(formName => formsObj[formName]);
    const onCancel = function () {
      if(confirm("All unsaved changes will be lost.")) {
        this.props.history.push('/');
      }
    }
    return (
      <FormTabs
        formTitle={title}
        currentTab={currentTab}
        onTabChange={onTabChange}
        tabs={tabs}
        isNew={isNew}
        edit={edit}
        pristine={pristine}
        onCancel={onCancel.bind(this)}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  permissionRole: state => state.app.user.permission_role,
  clients: selectClients(),
  channelName: selectChannelFormName(),
  password: selectChannelFormPassword(),
  modeId: selectChannelModeId(),
  currentTab: selectCurrentTab(),
  isPhotographer: selectIsPhotographer(),
  isFetching: selectIsFetching(),
  channelThemes: selectChannelThemes(),
  modes: selectModes(),
  enterpriseAdmins: selectEnterpriseAdmins(),
  useMoveboothTheme: selectUseMoveboothTheme(),
  errors: selectChannelErrors(),
  withFilter: selectChannelFormWithFilter(),
  slugIsValid: selectChannelSlugIsValid(),
  slugIsValidating: state => state.channels.slugIsValidating
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchClients: (q) => dispatch(fetchClientsRequest({ q })),
  fetchThemes: () => dispatch(fetchThemesRequest()),
  fetchModes: () => dispatch(fetchModesRequest()),
  onTabChange: (tab) => dispatch(changeTab(tab)),
  nextTab: (tabIndex) => dispatch(changeTab(tabIndex)),
  openColorPickerModal: (modalProps) =>
    dispatch(setModal({ modalType: COLOR_PICKER, modalProps })),
  onShrinkChange: (name, shrink) => {
    ownProps.change(name, shrink);
  }
});

export default reduxForm({
  form: "channelForm",
  validate,
  initialValues: {
    with_photo_filter: true,
    with_photo_filter_graphic: true,
    twitter: true,
    email: true,
    hashtag: "",
    company_promo: "",
    app_background_color: "",
    hashtag_enabled: false,
    company_promo_enabled: false,
    email_required: false,
    phone_required: false,
    twitter_required: false,
    email_enabled: true,
    phone_enabled: true,
    twitter_enabled: true,
    big_logo_image_url: null,
    gallery_color: "",
    photo_filters:null,
    sub_header: "",
    header: "",
    cta_text_link: "",
    gallery_cta_text: "",
    gallery_cta_link: "",
    is_new: true,
  },
})(connect(mapStateToProps, mapDispatchToProps)(withRouter(Forms)));



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/index.js